import { useEffect, useMemo, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarMenus from '../components/SidebarMenus';
import api from '../utils/api';
import '../assets/styles/dashboard.css';
import '../assets/styles/create-booking.css';
import '../assets/styles/booking-history.css';
import { Tooltip } from 'bootstrap';
import Header from '../components/Header';

const CURRENCY = process.env.REACT_APP_CURRENCY_SYMBOL || '$';

const STATUS_TABS = ['All', 'Pending', 'Accepted', 'In Progress', 'Completed', 'Cancelled'];

// const MOCK_BOOKINGS = [
//   {
//     id: 'TXB-4821',
//     customerName: 'Priya Sharma',
//     phone: '+1 (917) 553-4821',
//     pickup: 'Hilton Midtown',
//     dropoff: 'LaGuardia Airport',
//     driver: 'Marcus Johnson',
//     date: 'Jul 9, 2024',
//     time: '08:30 AM',
//     vehicle: 'Airport Pickup',
//     fare: 68,
//     commission: 6.8,
//     status: 'Completed',
//   },
//   {
//     id: 'TXB-4820',
//     customerName: 'James Wilson',
//     phone: '+1 (212) 884-1205',
//     pickup: 'Hyatt Regency Times Square',
//     dropoff: 'JFK Airport T4',
//     driver: 'Dmitri Volkov',
//     date: 'Jul 9, 2024',
//     time: '06:15 AM',
//     vehicle: 'Immediate',
//     fare: 52,
//     commission: 5.2,
//     status: 'In Progress',
//   },
//   {
//     id: 'TXB-4819',
//     customerName: 'Sarah Chen',
//     phone: '+1 (646) 221-8890',
//     pickup: 'Grand Hyatt NYC',
//     dropoff: 'Newark Airport',
//     driver: '—',
//     date: 'Jul 8, 2024',
//     time: '02:00 PM',
//     vehicle: 'Scheduled',
//     fare: 74,
//     commission: 7.4,
//     status: 'Accepted',
//   },
//   {
//     id: 'TXB-4818',
//     customerName: 'Michael Torres',
//     phone: '+1 (718) 440-1122',
//     pickup: 'Marriott Marquis',
//     dropoff: 'Brooklyn Bridge Park',
//     driver: '—',
//     date: 'Jul 8, 2024',
//     time: '11:45 AM',
//     vehicle: 'Immediate',
//     fare: 38,
//     commission: 3.8,
//     status: 'Pending',
//   },
//   {
//     id: 'TXB-4817',
//     customerName: 'Emily Davis',
//     phone: '+1 (917) 330-7788',
//     pickup: 'The Plaza Hotel',
//     dropoff: 'JFK Airport T1',
//     driver: 'Carlos Mendez',
//     date: 'Jul 7, 2024',
//     time: '05:30 AM',
//     vehicle: 'Airport Pickup',
//     fare: 61,
//     commission: 6.1,
//     status: 'Completed',
//   },
//   {
//     id: 'TXB-4816',
//     customerName: 'Robert Kim',
//     phone: '+1 (212) 555-0199',
//     pickup: 'Waldorf Astoria',
//     dropoff: 'LaGuardia Airport',
//     driver: '—',
//     date: 'Jul 6, 2024',
//     time: '09:00 AM',
//     vehicle: 'Scheduled',
//     fare: 55,
//     commission: 5.5,
//     status: 'Cancelled',
//   },
//   {
//     id: 'TXB-4815',
//     customerName: 'Lisa Anderson',
//     phone: '+1 (646) 882-3344',
//     pickup: 'Peninsula New York',
//     dropoff: 'JFK Airport T8',
//     driver: 'Mike Reynolds',
//     date: 'Jul 6, 2024',
//     time: '07:15 AM',
//     vehicle: 'Airport Pickup',
//     fare: 72,
//     commission: 7.2,
//     status: 'Completed',
//   },
// ];

function statusClass(status) {
  return status.toLowerCase().replace(/\s+/g, '-');
}

function shortenAddress(address, maxLen = 35) {
    if (!address) return '—';
    const full = address.trim();
    if (full.length <= maxLen) return full;
  
    const firstPart = full.split(',')[0].trim();
    if (firstPart.length <= maxLen) return firstPart;
  
    return `${full.slice(0, maxLen).trim()}…`;
  }
  
  function AddressLine({ address, className = '' }) {
    const full = address || '—';
    const short = shortenAddress(full);
    const ref = useRef(null);
  
    useEffect(() => {
      if (!ref.current || !address) return;
  
      const tip = Tooltip.getOrCreateInstance(ref.current, {
        title: full,
        placement: 'top',
        trigger: 'hover',
        container: 'body', // important inside tables
      });
  
      return () => tip.dispose();
    }, [address, full]);
  
    return (
      <div
        ref={ref}
        className={`bh-address ${className}`}
        data-bs-toggle="tooltip"
        data-bs-title={full}
      >
        {short}
      </div>
    );
  }

const BookingHistory = () => {
  const navigate = useNavigate();
  const agencyData = JSON.parse(localStorage.getItem('agencyData') || '{}');
  const partnerName = agencyData.companyName || 'Partner';
  const partnerEmail = agencyData.email || '';
  const initials = partnerName.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase();

  const [bookings, setBookings] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [statusDropdown, setStatusDropdown] = useState('All Status');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  useEffect(() => {
    console.log("caling booking list..................");
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }

    // When your API is ready, replace mock data:
     api.post('/api/website/agency-bookings', { agencyId: agencyData._id })
      .then((res) => setBookings(res.data.data || []))
      .catch(() => {});
  }, [navigate]);

  const filtered = useMemo(() => {
    return bookings.filter((b) => {
      const q = search.trim().toLowerCase();
      const matchesSearch =
        !q ||
        b.id.toLowerCase().includes(q) ||
        b.customerName.toLowerCase().includes(q) ||
        b.phone.includes(q);

      const activeStatus = statusFilter === 'All' ? null : statusFilter;
      const dropdownStatus =
        statusDropdown === 'All Status' ? null : statusDropdown;

      const matchesTab = !activeStatus || b.status === activeStatus;
      const matchesDropdown = !dropdownStatus || b.status === dropdownStatus;

      return matchesSearch && matchesTab && matchesDropdown;
    });
  }, [bookings, search, statusFilter, statusDropdown]);

  const handleExport = () => {
    const header = ['Booking ID', 'Customer', 'Phone', 'Pickup', 'Dropoff', 'Driver', 'Date', 'Time', 'Vehicle', 'Fare', 'Commission', 'Status'];
    const rows = filtered.map((b) => [
      b.id, b.customerName, b.phone, b.pickup, b.dropoff, b.driver,
      b.date, b.time, b.vehicle, b.fare, b.commission, b.status,
    ]);
    const csv = [header, ...rows].map((r) => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'booking-history.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  

  return (
    <div className="dashboard-layout">
      <SidebarMenus partnerName={partnerName} partnerEmail={partnerEmail} />

      <main className="dashboard-main">
        <Header title="Booking History" search={false} bell={true} partnerName={partnerName} initials={initials} searchPlaceholder="Search bookings, customers..." />

        <section className="bh-toolbar-card">
          <div className="bh-toolbar-row">
            <input
              className="bh-search"
              placeholder="Search by customer or booking ID..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <select
              className="bh-select"
              value={statusDropdown}
              onChange={(e) => setStatusDropdown(e.target.value)}
            >
              <option>All Status</option>
              {STATUS_TABS.filter((s) => s !== 'All').map((s) => (
                <option key={s}>{s}</option>
              ))}
            </select>
            <input type="date" className="bh-date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
            <input type="date" className="bh-date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
            <button type="button" className="bh-btn-outline" onClick={handleExport}>
              ↓ Export
            </button>
            <button type="button" className="bh-btn-primary" onClick={() => navigate('/create-booking')}>
              ＋ New Booking
            </button>
          </div>

          <div className="bh-tabs">
            {STATUS_TABS.map((tab) => (
              <button
                key={tab}
                type="button"
                className={`bh-tab${statusFilter === tab ? ' active' : ''}`}
                onClick={() => setStatusFilter(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </section>

        <section className="bh-table-card">
          <div className="bh-table-head">
            <h3>All Bookings <span className="bh-count">[{filtered.length}]</span></h3>
          </div>

          <div className="table-scroll">
            <table className="bh-table">
              <thead>
                <tr>
                  <th>Booking ID</th>
                  <th>Customer</th>
                  <th>Pickup → Dropoff</th>
                  <th>Driver</th>
                  <th>Date & Time</th>
                  <th>Vehicle</th>
                  <th>Fare</th>
                  <th>Commission</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                
                {filtered.map((b) => (
                  <tr key={b.id}>
                    <td>
                      <button
                        type="button"
                        className="bh-link"
                        onClick={() => navigate(`/booking-details?id=${b._id || b.id}`)}
                      >
                        {b.id}
                      </button>
                    </td>
                    <td>
                      <div className="bh-customer-name">{b.customerName}</div>
                      <div className="bh-muted">{b.phone}</div>
                    </td>
                    <td>
                    <AddressLine address={b.pickup ?? b.from_address ?? b.from_location} />
                    <div className="bh-route">
                        <span className="bh-arrow">→</span>{' '}
                        <AddressLine address={b.dropoff ?? b.to_address ?? b.to_location} />
                    </div>
                    </td>
                    <td>{b.driver}</td>
                    <td>
                      <div>{b.date}</div>
                      <div className="bh-muted">{b.time}</div>
                    </td>
                    <td><span className="bh-vehicle-tag">{b.vehicle}</span></td>
                    <td className="bh-fare">{CURRENCY} {b.fare}</td>
                    <td className="bh-commission">{CURRENCY} {b.commission}</td>
                    <td>
                      <span className={`bh-status ${statusClass(b.status)}`}>
                        <span className="bh-status-dot" />
                        {b.status}
                      </span>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="bh-view-btn"
                        onClick={() => navigate(`/booking-details?id=${b._id || b.id}`)}
                      >
                        👁 View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
};

export default BookingHistory;